import { Box } from '@radix-ui/themes';
import { FormInputWrapperDef } from 'interfaces/form/input-wrapper';
import { ReactNode } from 'react';

export const FormInputWrapper = (
  props: FormInputWrapperDef & { children: ReactNode }
) => {
  return (
    <Box
      className={props.className}
      gridColumn={props.gridColumn}
      gridColumnStart={props.gridColumnStart}
    >
      {props.children}
    </Box>
  );
};
